import { render, staticRenderFns } from "./messageTypeSelecter.vue?vue&type=template&id=6c7974d1&scoped=true&"
import script from "./messageTypeSelecter.vue?vue&type=script&lang=js&"
export * from "./messageTypeSelecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7974d1",
  null
  
)

export default component.exports